export const DATE_PLACEHOLDER = 'MM/DD/YYYY';

export const TIME_PLACEHOLDER = '00:00:00 --';
